'use client';

import { TenantLogo } from './tenant-logo';
import { cn } from '@/lib/utils';

/** Shared company identity for public job cards and details. Fixed dimensions
 * keep missing/broken logos from shifting the title or collapsing a wordmark. */
export function CompanyLogo({ name, light, dark, className }: {
  name: string;
  light?: string | null;
  dark?: string | null;
  className?: string;
}) {
  const label = name.trim() || 'Company';
  const fallback = (
    <span role="img" aria-label={label} className="flex h-11 w-11 items-center justify-center rounded-lg bg-muted text-foreground text-lg font-bold">
      {Array.from(label)[0].toUpperCase()}
    </span>
  );
  return (
    <div className={cn('flex h-11 shrink-0 items-center justify-start', light ? 'w-24' : 'w-11', className,
      light && (dark ? 'bg-white dark:bg-background' : 'bg-white'))}>
      {light ? <TenantLogo light={light} dark={dark} alt={label} width={96} height={44}
        className="h-full w-full object-contain object-left" fallback={fallback} /> : fallback}
    </div>
  );
}
